
/* injects from baggage-loader */

'use strict';

export default class DonationConfirmationController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
